/**
 * Links between Mobstr and InterroPol.
 *
 * InterroPol is served at /interropol on the same origin, so it shares Mobstr's
 * login (the tokenmob JWT in localStorage) with no hand-off. If it is ever hosted
 * on another origin, set REACT_APP_INTERROPOL_URL to its absolute URL: links then
 * carry the token in the URL fragment (never sent to a server), which
 * InterroPol's adoptTokenFromUrl() picks up and strips.
 */
export const INTERROPOL_BASE = process.env.REACT_APP_INTERROPOL_URL || "/interropol/";

/** Same rule as the API: organisation has InterroPol, or super/internal user. */
export function canUseInterropol(user) {
  return !!(user && (user.organization?.hasInterropol || user.isSuperUser || user.isInternalUser));
}

/** URL of an InterroPol page, e.g. interropolUrl("apps/com.example.app"). */
export function interropolUrl(path = "", { base = INTERROPOL_BASE, origin = typeof window !== "undefined" ? window.location.origin : "", token } = {}) {
  const root = base.endsWith("/") ? base : `${base}/`;
  const url = `${root}${String(path).replace(/^\//, "")}`;
  const crossOrigin = /^https?:\/\//i.test(root) && !root.startsWith(`${origin}/`);
  return crossOrigin && token ? `${url}#token=${encodeURIComponent(token)}` : url;
}
